import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getCertificate = () => {
  return apiRequestType(apiTypes.GET, apiConstants.DISTRIBUTE.GET_CERTIFICATE);
};

export default getCertificate;
